import styled from '@emotion/styled'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import CustomSourcesImage from './CustomSourcesImage'

const copy = {
  overline: `Unlock custom sources and destinations`,
  heading: `Integrate each and every API`,
  description1: `Collect and transform any stream of first-party customer data from webhooks into Segment events. Transform and map events collected by Segment to new destinations and internal services.`,
}

export const Sources = () => {
  return (
    <Wrapper>
      <SectionComponent variant="2Col" copyVariant="narrow">
        <Section.Copy alignSelf="center">
          <CopyTextBase>
            <CopyText.Overline>{copy.overline}</CopyText.Overline>
            <CopyText.Heading tag="h2">{copy.heading}</CopyText.Heading>
            <CopyText.Description tag="h2">{copy.description1}</CopyText.Description>
          </CopyTextBase>
        </Section.Copy>
        <Section.Contents>
          <CustomSourcesImage />
        </Section.Contents>
      </SectionComponent>
    </Wrapper>
  )
}

const SectionComponent = styled(SectionBase)`
  overflow-x: visible;
  justify-content: center;
  ${Section.Wrapper} {
    padding-top: 176px;
    padding-bottom: 80px;
    ${({ theme }) => theme.breakpoints.down(`md`)} {
      padding-top: 40px;
      padding-bottom: 40px;
    }
  }
`

const Wrapper = styled.div``

export default Sources
